import React, { useState, useEffect } from "react";
import "./PaymentsDone.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";

const Payments = () => {
  const [Paydata, setPaydata] = useState([]);
  const [yearlyData, setYearlyData] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [allData, setAllData] = useState({
    totalQuantity: 0,
    totalUsed: 0,
    totalDamaged: 0,
  });

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getVendor").then((response) => {
      const reversedData = response.data.reverse();
      setPaydata(reversedData);
      const yearlyStats = {};
      reversedData.forEach((row) => {
        const rowDate = new Date(row.Date);
        const year =
          rowDate.getMonth() >= 3
            ? rowDate.getFullYear() + 1
            : rowDate.getFullYear();
        if (!yearlyStats[year]) {
          yearlyStats[year] = {
            totalQuantity: 0,
            totalUsed: 0,
            totalDamaged: 0,
          };
        }
        yearlyStats[year].totalQuantity += row.Totalamount;
        yearlyStats[year].totalUsed += row.PaymentUpdates.reduce(
          (acc, item) => acc + item.Paid,
          0
        );
      });

      for (const year in yearlyStats) {
        yearlyStats[year].totalDamaged =
          yearlyStats[year].totalQuantity - yearlyStats[year].totalUsed;
      }
      setYearlyData(yearlyStats);
    });
  }, [selectedYear]);

  useEffect(() => {
    const allYearsData = {
      totalQuantity: 0,
      totalUsed: 0,
      totalDamaged: 0,
    };

    Paydata.forEach((row) => {
      const rowDate = new Date(row.Date);
      const year =
        rowDate.getMonth() >= 3
          ? rowDate.getFullYear() + 1
          : rowDate.getFullYear();

      // Check if the row's year matches the selected year
      if (selectedYear === "all" || parseInt(selectedYear) === year) {
        allYearsData.totalQuantity += row.Totalamount;
        allYearsData.totalUsed += row.PaymentUpdates.reduce(
          (acc, item) => acc + item.Paid,
          0
        );
        allYearsData.totalDamaged +=
          row.Totalamount -
          row.PaymentUpdates.reduce((acc, item) => acc + item.Paid, 0);
      }
    });

    setAllData(allYearsData);
  }, [selectedYear, Paydata]); // Add selectedYear and Paydata as dependencies

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    years.push(
      <option key="all" value="all">
        All
      </option>
    );

    const uniqueYears = new Set();
    for (let year in yearlyData) {
      uniqueYears.add(year);
    }
    uniqueYears.add((currentYear + 1).toString()); // Add next financial year
    uniqueYears.forEach((year) => {
      years.push(
        <option key={year} value={year}>
          FY-{parseInt(year) - 1}-{year}
        </option>
      );
    });
    return years;
  };

  const handleYearChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedYear(selectedValue === "all" ? "all" : parseInt(selectedValue));
  };

  return (
    <div className="paymentdone">
      <h2 style={{ marginBottom: "2rem" }}>Payments</h2>
      <div>
        <label style={{ marginBottom: "2rem" }} htmlFor="yearSelector">
          Select Year :-
        </label>
        <select
          id="yearSelector"
          name="yearSelector"
          onChange={handleYearChange}
          value={selectedYear}
        >
          {getYearOptions()}
        </select>
        {selectedYear !== "all" && yearlyData[selectedYear] && (
          <>
            <p>
              YTD Invoice Amount:{" "}
              <b> {yearlyData[selectedYear].totalQuantity.toFixed(2)}</b>
            </p>
            <p>
              YTD Paid by Pinnacle:
              <b> {yearlyData[selectedYear].totalUsed.toFixed(2)}</b>{" "}
            </p>
            <p>
              YTD Pending Amount:{" "}
              <b> {yearlyData[selectedYear].totalDamaged.toFixed(2)}</b>
            </p>
          </>
        )}

        {selectedYear === "all" && (
          <>
            <p>
              YTD Invoice Amount:<b> {allData.totalQuantity.toFixed(2)}</b>
            </p>
            <p>
              YTD Paid by Pinnacle:<b> {allData.totalUsed.toFixed(2)}</b>
            </p>
            <p>
              YTD Pending Amount:<b> {allData.totalDamaged.toFixed(2)}</b>
            </p>
          </>
        )}
      </div>
      <Table className="paymentdonetable">
        <thead>
          <tr>
            <th>Invoice No.</th>
            <th>Invoice Date</th>
            <th>Invoice Amount</th>
            <th>Paid Amount</th>
            <th>Paid Amt.Date</th>
          </tr>
        </thead>
        <tbody>
          {Paydata.map((row) => (
            <React.Fragment key={row.invoiceno}>
              {row.PaymentUpdates.map((item, index) => (
                <tr key={item._id}>
                  {index === 0 ? ( // Render shipmentid and DistributorName only for the first item
                    <>
                      <td rowSpan={row.PaymentUpdates.length}>
                        {row.invoiceno}
                      </td>

                      <td rowSpan={row.PaymentUpdates.length}>
                        {new Date(row.Date).toLocaleDateString("en-US", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })}
                      </td>

                      <td rowSpan={row.PaymentUpdates.length}>
                        {row.Totalamount.toFixed(2)}
                      </td>
                    </>
                  ) : null}
                  <td>{item.Paid}</td>
                  <td>{item.PaymentDate}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Payments;
